export default "__VITE_ASSET__CKbh5mKn__"